
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    //@Serenity.Decorators.panel()
    export class PriceListDialog extends _Ext.DialogBase<PriceListRow, any> {
        protected getFormKey() { return PriceListForm.formKey; }
        protected getIdProperty() { return PriceListRow.idProperty; }
        protected getLocalTextPrefix() { return PriceListRow.localTextPrefix; }
        protected getNameProperty() { return PriceListRow.nameProperty; }
        protected getService() { return PriceListService.baseUrl; }
        protected getDeletePermission() { return PriceListRow.deletePermission; }
        protected getInsertPermission() { return PriceListRow.insertPermission; }
        protected getUpdatePermission() { return PriceListRow.updatePermission; }
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }


        public form = new PriceListForm(this.idPrefix);
        constructor() {
            super();

            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 300;
            Config.autoHeight = false;
            q.initDetailEditor(this, this.form.RateDetails, Config);
            q.initDetailEditor(this, this.form.ItemDetails, Config);
            q.initDetailEditor(this, this.form.LaborDetails, Config);

            q.SetCategoryFullWidth(this.form.PriceCode);
            q.SetCategoryFullWidth(this.form.RateDetails);
            q.hideEditorLabel(this.form.RateDetails);
            q.hideEditorLabel(this.form.ItemDetails);
            q.hideEditorLabel(this.form.LaborDetails);
            q.HideCategoryLable(this.element);
            this.form.PriceType.changeSelect2(e => {
                var cols = this.form.LaborDetails.cols;
                this.form.RateDetails.slickGrid.setColumns(cols);
                //alert(cols.length);
                if (this.form.PriceType.value != "") {
                    //alert(this.form.PriceType.value);
                    var x = FixedCodeRow.getLookup().itemById[this.form.PriceType.value].FixedName;
                    //this.form.RateDetails.slickGrid.updateRow(0);
                    if (x == "PURCHASE RATE") {
                        var temp = cols.filter(x => x.field != "SaleStdRate");
                        //this.form.RateDetails.setItems([]);
                        this.form.RateDetails.slickGrid.setColumns(temp);
                    } else if (x == "SALE RATE") {
                        var temp = cols.filter(x => x.field != "PurStdRate")
                        //this.form.RateDetails.setItems([]);
                        this.form.RateDetails.slickGrid.setColumns(temp);


                    }
                }

            });

            //q.setGridEditorHeight(this.form.RateDetails, 300);

            this.form.PriceCode.changeSelect2(e => {
                try {
                    var id = PriceListRow.getLookup().items.filter(x => x.PriceCode.toUpperCase() == this.form.PriceCode.value)[0];
                    if (id != undefined) {
                        if (id.PricelistId != null || id.PricelistId > 0) {
                            Q.notifyError("Duplicate Collection " + this.form.PriceCode.value);
                            this.form.PriceCode.value = "";
                            return;

                        }
                    }
                    else {
                        this.form.PriceCode.value = this.form.PriceCode.value.toUpperCase();
                    }
                }
                catch (undefined) {

                }

            });

            (this.form.RateDetails.view as any).onRowCountChanged.subscribe(() => {
                let Items = this.form.RateDetails.getItems().length;
                if (Items > 0)
                    q.showAndDisableField(this.form.PriceType);
                else
                    q.showAndEnableField(this.form.PriceType);
            });

            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => {
                let Items = this.form.ItemDetails.getItems().length;
                if (Items > 0)
                    q.showAndDisableField(this.form.PriceType);
                else
                    q.showAndEnableField(this.form.PriceType);
            });
            (this.form.LaborDetails.view as any).onRowCountChanged.subscribe(() => {
                let Items = this.form.LaborDetails.getItems().length;
                if (Items > 0)
                    q.showAndDisableField(this.form.PriceType);
                else
                    q.showAndEnableField(this.form.PriceType);
            });
        }

        protected onDialogOpen() {
            super.onDialogOpen();

            if (this.form.PriceCode.value != "") {
                var x = FixedCodeRow.getLookup().itemById[this.form.PriceType.value].FixedName;
                var cols = this.form.RateDetails.cols;
                //this.form.RateDetails.slickGrid.updateRow(0);
                if (x == "PURCHASE RATE") {
                    var temp = cols.filter(x => x.field != "SaleStdRate");
                    //this.form.RateDetails.setItems([]);
                    this.form.RateDetails.slickGrid.setColumns(temp);
                } else if (x == "SALE RATE") {
                    var temp = cols.filter(x => x.field != "PurStdRate")
                    //this.form.RateDetails.setItems([]);
                    this.form.RateDetails.slickGrid.setColumns(temp);
                }

            }
        }

    }
}